
export const CounsellorsData = [
    {
        imgURL : 'https://falmed.pl/wp-content/uploads/2015/05/team1.jpg',
        name : 'Mr. Shown',
        desc : 'Always laugh when you can, it is cheap medicine.',
        study : 'Psychologist', 
        exp : '10 Years', 
        qual : 'P.H.D, M.Tech',
    },
    {
        imgURL : 'https://ewh.org.uk/wp-content/themes/theme/img/home-v2/john-doe.png',
        name : 'Mr. John',
        desc : 'Let food be thy medicine and medicine be thy food.',
        study : 'Psychologist', 
        exp : '10 Years', 
        qual : 'P.H.D, M.Tech',
    },
    {
        imgURL : 'https://png.pngitem.com/pimgs/s/490-4900474_3-transparent-female-doctor-png-png-download.png',
        name : 'Mr. Emma ',
        desc : "Isn't it a bit unnerving that doctors call what they do ",
        study : 'Psychologist', 
        exp : '10 Years', 
        qual : 'P.H.D, M.Tech',
    },
    {
        imgURL : 'https://cdn.gutensite.com/web001/site/7398/843689/843689-xl.png',
        name : 'Mr. Cyrus',
        desc : 'Always laugh when you can, it is cheap medicine.',
        study : 'Psychologist', 
        exp : '10 Years', 
        qual : 'P.H.D, M.Tech',
    },{
        imgURL : 'https://falmed.pl/wp-content/uploads/2015/05/team1.jpg',
        name : 'Mr. Shown',
        desc : 'Always laugh when you can, it is cheap medicine.',
        study : 'Psychologist', 
        exp : '10 Years', 
        qual : 'P.H.D, M.Tech',
    },
    {
        imgURL : 'https://ewh.org.uk/wp-content/themes/theme/img/home-v2/john-doe.png',
        name : 'Mr. John',
        desc : 'Let food be thy medicine and medicine be thy food.',
        study : 'Psychologist', 
        exp : '10 Years', 
        qual : 'P.H.D, M.Tech',
    },
    {
        imgURL : 'https://png.pngitem.com/pimgs/s/490-4900474_3-transparent-female-doctor-png-png-download.png',
        name : 'Mr. Emma ',
        desc : "Isn't it a bit unnerving that doctors call what they do ",
        study : 'Psychologist', 
        exp : '10 Years', 
        qual : 'P.H.D, M.Tech',
    },
    {
        imgURL : 'https://cdn.gutensite.com/web001/site/7398/843689/843689-xl.png',
        name : 'Mr. Cyrus',
        desc : 'Always laugh when you can, it is cheap medicine.',
        study : 'Psychologist', 
        exp : '10 Years', 
        qual : 'P.H.D, M.Tech',
    },{
        imgURL : 'https://falmed.pl/wp-content/uploads/2015/05/team1.jpg',
        name : 'Mr. Shown',
        desc : 'Always laugh when you can, it is cheap medicine.',
        study : 'Psychologist', 
        exp : '10 Years', 
        qual : 'P.H.D, M.Tech',
    }
]